import { render } from "./EditCommune.vue?vue&type=template&id=525336a0&scoped=true"
import script from "./EditCommune.vue?vue&type=script&lang=js"
export * from "./EditCommune.vue?vue&type=script&lang=js"

import "./EditCommune.vue?vue&type=style&index=0&id=525336a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525336a0"]])

export default __exports__